import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/PublicLayout.css';

/**
 * PublicLayout - Layout for public booking pages (no authentication)
 * Used for: /book/:slug (MongoDB ID), /booking/:code, etc.
 */
const PublicLayout = ({ children, showLanguageSwitcher = true }) => {
  return (
    <div className="public-layout" dir="rtl">
      {/* Header */}
      <header className="public-header">
        <div className="container">
          <div className="header-content">
            {/* Logo */}
            <Link to="/" className="logo">
              <span className="logo-text">Host Me</span>
            </Link>

            {/* Language Switcher (if enabled) */}
            {showLanguageSwitcher && (
              <div className="language-switcher">
                <button className="lang-btn active">العربية</button>
                <button className="lang-btn">English</button>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="public-main">
        {children}
      </main>

      {/* Footer */}
      <footer className="public-footer">
        <div className="container">
          <div className="footer-content">
            <p>© 2025 Host Me - منصة إدارة العقارات</p>
            <p className="footer-note">
              جميع الحقوق محفوظة
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PublicLayout;
